export const langcodes = Object.freeze(["de","fr","en"]);
export const languages = Object.freeze([
  {
    "code": "de",
    "prefix": "de",
    "label": "Deutsch"
  },
  {
    "code": "fr",
    "prefix": "fr",
    "label": "Français"
  },
  {
    "code": "en",
    "prefix": "en",
    "label": "English"
  }
]);
export const debug = true;
export const defaultLanguageNoPrefix = false;
export const defaultLangcode = "de";
export const prefixToLangcode = Object.freeze({
  "de": "de",
  "fr": "fr",
  "en": "en"
});
export const langcodeToPrefix = Object.freeze({
  "de": "de",
  "fr": "fr",
  "en": "en"
});